export default {
    left: {
        '& > :first-of-type': {
            pr: '12px',
        },
        '&:before': {
            display: 'none',
        },
    },
    center: {
        '& > :first-of-type': {
            px: '12px',
        },
    },
    right: {
        '& > :first-of-type': {
            pl: '12px',
        },
        '&:after': {
            display: 'none',
        },
    },
};
